<script>
    export default {
        props: {
            file: Object,
        },
        methods: {
            async showBigPreview() {
                this.$store.commit('SELECT_FILE', this.file);
                this.$store.commit('IS_SHOW_BIG_PREVIEW', true);
            }
        }
    }
</script>


<template>
    <div
        @click="showBigPreview"  
    >
        <img :src="file.imagePreview">
    </div>    
</template>


<style scoped>
    /* [FIX] Mirror ImagePreview's sizing: a fixed 300px column with a width-capped
       image. Without this the raw <img> rendered at its natural size (e.g. 1960px),
       blowing out the flex row so the sibling disable-text panel collapsed and the
       deactivated-file view showed a giant image over a grey void. */
    div {
        flex: 0 0 300px;
        padding: 10px;
        margin: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    div:hover {
        background-color: var(--image-hover);
        border-radius: 5px;
    }
    img {
        width: 100%;
        height: auto;
        background-image: url('@/../assets/images/transperent.jpg');
    }
</style>